import script from "./Marquee.vue?vue&type=script&setup=true&lang=js"
export * from "./Marquee.vue?vue&type=script&setup=true&lang=js"

import "./Marquee.vue?vue&type=style&index=0&id=e0f11f3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0f11f3a"]])

export default __exports__